import { lineString, point } from "@turf/helpers";
import { toMercator, toWgs84 } from "@turf/projection";
import along from "@turf/along";
import lineDistance from "@turf/line-distance";
import lineSlice from "@turf/line-slice";
import lineOffset from "@/libs/line-offset";

export const getArrowsAlongLine = (
  lineCoords,
  pointCoords,
  distance,
  offset
) => {
  // set options
  const options = {
    units: "metres"
  };

  // 1. create features
  const line = lineString(lineCoords);
  const startPoint = point(lineCoords[0]);
  const currentPoint = point(pointCoords);

  // 2. get distance between start point and current point
  const slicedLine = lineSlice(startPoint, currentPoint, line);
  const distanceToCurrent = lineDistance(slicedLine, "meters");

  // 3. get start and end points of arrow and arrow feature
  const arrowStartPoint = along(
    line,
    distanceToCurrent - distance / 2,
    options
  );
  const arrowEndPoint = along(line, distanceToCurrent + distance / 2, options);
  const arrowFeature = lineString(
    [arrowStartPoint.geometry.coordinates, arrowEndPoint.geometry.coordinates],
    { type: "direct" }
  );

  // 4. get arrow feature in mercator projection for calculations
  const mercatorArrowFeature = toMercator(arrowFeature);

  // 5. get direct and reverse arrows with offset
  const directArrowLine = lineOffset(mercatorArrowFeature, offset, options);
  const reverseArrowLine = lineOffset(mercatorArrowFeature, -offset, options);

  // 6. get result features in WGS84
  const direct = toWgs84(directArrowLine);
  const reverse = toWgs84(
    lineString(reverseArrowLine.geometry.coordinates.reverse(), {
      type: "reverse"
    })
  );

  return {
    direct,
    reverse
  };
};
